import { render } from "./MoveControls.vue?vue&type=template&id=434f93e4&scoped=true&ts=true"
import script from "./MoveControls.vue?vue&type=script&lang=ts"
export * from "./MoveControls.vue?vue&type=script&lang=ts"

import "./MoveControls.vue?vue&type=style&index=0&id=434f93e4&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434f93e4"]])

export default __exports__